"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadFile = exports.HOSTS = exports.API_METHODS = void 0;
var react_1 = require("react");
var axios_1 = __importDefault(require("axios"));
var API_METHODS;
(function (API_METHODS) {
    API_METHODS["POST"] = "post";
})(API_METHODS = exports.API_METHODS || (exports.API_METHODS = {}));
exports.HOSTS = {
    development: 'https://media-upload.whispirdev.com/media',
    staging: 'https://media-upload-stage.whispirdev.com/media',
};
var useUploadFile = function (endpointUrl) {
    var _a = (0, react_1.useState)(undefined), response = _a[0], setResponse = _a[1];
    var _b = (0, react_1.useState)(undefined), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var api = axios_1.default.create({
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data; application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json',
        },
    });
    var uploadImage = (0, react_1.useCallback)(function (_a) {
        var file = _a.file;
        setResponse(undefined);
        setLoading(true);
        setError(undefined);
        var body = new FormData();
        body.append('files', file);
        api(endpointUrl, {
            method: API_METHODS['POST'],
            data: body,
        })
            .then(function (res) {
            var _a, _b;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.returnData)
                setResponse((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.returnData);
        })
            .catch(function (err) {
            var _a, _b;
            var parsedError = JSON.parse(((_a = err === null || err === void 0 ? void 0 : err.request) === null || _a === void 0 ? void 0 : _a.response) || '""');
            if (((_b = err === null || err === void 0 ? void 0 : err.request) === null || _b === void 0 ? void 0 : _b.status) === 0) {
                setError('The file you uploaded is too large. We support files up to 6mb');
            }
            else {
                setError((parsedError === null || parsedError === void 0 ? void 0 : parsedError.message.length) > 0 ? parsedError.message : err.message);
            }
        })
            .finally(function () {
            setLoading(false);
        });
    }, [api]);
    var reset = function () {
        setResponse(undefined);
        setLoading(false);
        setError(undefined);
    };
    return { uploadImage: uploadImage, response: response, loading: loading, error: error, reset: reset };
};
exports.useUploadFile = useUploadFile;
exports.default = exports.useUploadFile;
